import * as yup from 'yup';

import { InsightsReportType } from '../types';

export const insightsReportFormValidationSchema = yup.object({
  type: yup.string().required(),
  dataAggregationLevel: yup.string().when(['$type'], {
    is: (type: InsightsReportType) => ![InsightsReportType.SETTLEMENTS, InsightsReportType.RATINGS].includes(type),
    then: yup.string().required(),
  }),
  reportFrequency: yup.array().min(1, { id: 'insights.reports.frequency.error-required' }).required(),
  venueIds: yup.array().min(1, { id: 'insights.reports.venues.error-required' }).required(),
  dataOptions: yup.array().min(1, { id: 'insights.reports.data-options.error-required' }).required(),
});
